import RecipientsSection from './recipients-section.vue';

export default RecipientsSection;
